import { defineBoot } from '#q-app/wrappers'
import axios from 'axios'
import { Notify } from 'quasar'


// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)


const api = axios.create({ baseURL: process.env.API })

export default defineBoot(({ app, router }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  app.config.globalProperties.$api = api
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API

  api.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error.response?.data?.errors) {
        error.response.data.errors.forEach(error => {
          Notify.create({
            type: 'error',
            message: error.message
          })
        })
      } else {
        if (error.response?.status === 401 && error.response?.data?.message !== 'Invalid credentials') {
          router.push({ name: 'login' })
        }
        if (error.response?.data?.message && error.response?.data?.message !== 'Invalid credentials') {
          Notify.create({
            type: 'error',
            message: error.response?.data?.message
          })
        }
      }
      return Promise.reject(error)
    }
  )
})

export { api }
